import xorBy from 'lodash/xorBy';
import uniqBy from 'lodash/uniqBy';
import { translate } from '../../locales';

export const isSelectedOrDisabledItem = (item, selectedOptions) => {
  return (
    item.isDisabled ||
    selectedOptions.some(option => option.value === item.value)
  );
};

export const countSelection = (values, maxValues) => {
  const totalSelected = values.length;
  const count =
    maxValues < Infinity ? `${totalSelected}/${maxValues}` : totalSelected;
  const label = translate('multi.selected', { count });
  return label;
};

export const sortOptions = ({ options, values }) => {
  const unselectedOptions = xorBy(values, options, 'value');

  return [...values, ...unselectedOptions];
};

export const sortValues = ({ values }) => {
  const withGroup = values.filter(v => v.groupName);
  const withoutGroup = values.filter(v => !v.groupName);

  return [...withGroup, ...withoutGroup];
};

export const shouldCreateNewOption = (input, options) => {
  return !options.some(option => option.value === input);
};

export function getSelectedOptionsRange({
  isShiftKeyPressed,
  startOfSelectionRange,
  currentOptionIndex,
  isSelectAction,
  isDeselectAction,
  collection,
  newValues,
  isOptionDisabled,
  selectedOptions,
  maxValues
}) {
  if (!isShiftKeyPressed) {
    return newValues;
  }

  const isBackWardsRange = startOfSelectionRange.index > currentOptionIndex;

  const start = isBackWardsRange
    ? currentOptionIndex
    : startOfSelectionRange.index;

  const end = isBackWardsRange
    ? startOfSelectionRange.index
    : currentOptionIndex;

  if (isSelectAction) {
    const selectedOptionsInRange = collection.slice(start, end + 1);

    const uniqueSelectedOptions = uniqBy(
      [...selectedOptions, ...selectedOptionsInRange],
      'value'
    );

    if (uniqueSelectedOptions.length > maxValues) {
      // in case the user range-selected more than allowed in total,
      // return the first and last items in range (with previous selected items) and ignore the range
      return newValues;
    }

    // we remove items that exists in range because order matters.
    const filteredNewValues = newValues.filter(
      newOpt =>
        !selectedOptionsInRange.some(
          selectedOption => selectedOption.value === newOpt.value
        )
    );
    const allSelectedOptions = [
      ...filteredNewValues,
      ...selectedOptionsInRange
    ];
    const uniqueOptions = uniqBy(allSelectedOptions, 'value');
    const withoutDisabledOptions = uniqueOptions.filter(
      o => !o.isDisabled && !isOptionDisabled(o)
    );
    return withoutDisabledOptions;
  }

  if (isDeselectAction) {
    const selectedOptionsInRange = collection.slice(start, end + 1);

    const allSelectedOptions = newValues.filter(
      newOpt =>
        !selectedOptionsInRange.some(
          selectedOption => selectedOption.value === newOpt.value
        )
    );
    const uniqueOptions = uniqBy(allSelectedOptions, 'value');
    return uniqueOptions;
  }

  // In case we got here with an action we don't support, no logic took place.
  return newValues;
}
